var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(.5)"},[React.createElement("rect",{"width":"49.421","height":"49.421","fill":"#0D0D0D","rx":"1","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M33.92 18.998c-.677.3-1.406.504-2.17.595a3.79 3.79 0 0 0 1.661-2.09 7.566 7.566 0 0 1-2.4.917 3.78 3.78 0 0 0-6.44 3.447 10.728 10.728 0 0 1-7.788-3.95 3.777 3.777 0 0 0 1.17 5.045 3.764 3.764 0 0 1-1.712-.472v.048a3.781 3.781 0 0 0 3.031 3.705 3.786 3.786 0 0 1-1.706.065 3.783 3.783 0 0 0 3.53 2.625 7.582 7.582 0 0 1-5.595 1.564 10.696 10.696 0 0 0 5.793 1.698c6.95 0 10.752-5.758 10.752-10.752 0-.164-.004-.327-.011-.489a7.68 7.68 0 0 0 1.885-1.956z","key":1})]));
}

TwitterInline.defaultProps = {"width":"50","height":"50"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
